"use client";

import { scrollToElement } from "@/utils/browser-utils";
import Link from "next/link";

export default function PaymentInstructions() {
  return (
    <div className="max-w-2xl text-left">
      <div>
        <h3 className="text-xl font-bold">How to enroll:</h3>
        <ol className="mt-6 space-y-2">
          <li className="flex gap-1">
            <p className="flex-shrink-0">Step 1:</p>
            <p>
              Purchase the course by sending course fee to the{" "}
              <Link
                href="#payment-address"
                className="underline underline-offset-2"
                onClick={(e) => scrollToElement(e, "enroll", "payment-address")}
              >
                bank details given below
              </Link>
            </p>
          </li>
          <li className="flex gap-1">
            <p className="flex-shrink-0">Step 2:</p>
            <p>
              After sending the payment,{" "}
              <Link
                href="#payment-form"
                className="underline underline-offset-2"
                onClick={(e) => scrollToElement(e, "enroll", "payment-form", 36)}
              >
                fill the form below
              </Link>{" "}
              and attach your payment receipt/screenshot
            </p>
          </li>
          <li className="flex gap-1">
            <p className="flex-shrink-0">Step 3:</p>
            <p>
              Wait for the admin to confirm your payment (can take upto 24 hours, watch payment status on course page)
            </p>
          </li>
        </ol>
      </div>

      <div className="mt-8 flex flex-col gap-4 text-muted-foreground">
        <p>
          After confirmation, you will receive a greeting email and greeting card on the course page. You can also track
          payment status and watch course content right from the course page.
        </p>

        <p>
          Note: For now, we only support manual payments with recepit approval. In future, we will add support for
          automatic payments using credit/debit cards plus support for many other prominent mobile wallets of Pakistan.
        </p>
      </div>
    </div>
  );
}
